import React from 'react';
// @mui
import { TableCell } from '@mui/material';
export default class GridArrayCell extends React.Component {
    render() {
        // props: value, id, field
        //show value with comma separated
        const display = this.props.field.display;
        if (!this.props.value || !this.props.value.length) {
            return (
                <TableCell key={this.props.field.id} align="left">
                    -
                </TableCell>
            );
        }
        const baseStyle = this.props.styles;

        return (
            <TableCell
                key={this.props.field.id}
                align="left"
                sx={{
                    ...(this.props.field.boldText && { fontWeight: 'bold' }),
                    ...baseStyle
                }}
            >
                {this.props.value.map((item, index) => {
                    const text = typeof item === 'string' ? item : item[display];
                    if (!item) return null;
                    return (
                        <span key={index}>
                            {text}
                            {index < this.props.value.length - 1 ? ', ' : ''}
                        </span>
                    );
                })}
            </TableCell>
        );
    }
}
